/**
 * The title screen's menu, as data. Pure so the "which route does this entry
 * go to, and what does the keyboard do to the selection" logic is testable
 * without mounting anything.
 *
 * This is not the original's whole MAIN MENU (`docs/game/ui-menus.md` has that
 * tree: FLY SINGLE MISSION, CAREER MENU, VIEW AIRPLANES, …). FLY SINGLE MISSION
 * and the CAREER MENU are real now; VIEW AIRPLANES, the Historic Encounters and
 * the Mission Recorder still need front-ends that do not exist. The entries
 * below are what this port can actually do today.
 */

export interface TitleMenuItem {
  readonly id: string;
  readonly label: string;
  readonly path: string;
  readonly hint: string;
}

export const TITLE_MENU_ITEMS: readonly TitleMenuItem[] = [
  {
    id: "career",
    label: "CAREER",
    path: "/career",
    hint: "Enlist, fly a war of generated missions, and live with it",
  },
  {
    id: "missions",
    label: "FLY SINGLE MISSION",
    path: "/missions",
    hint: "Duels, patrols, escorts, balloons and airships",
  },
  { id: "fly", label: "DOGFIGHT (INSTANT)", path: "/fly", hint: "Straight into a Camel, Albatros astern" },
  {
    id: "duel",
    label: "MULTIPLAYER",
    path: "/duel",
    hint: "Head-to-head over a room code — one aeroplane each, no AI",
  },
  { id: "assets", label: "ASSETS", path: "/assets", hint: "Baked-asset review suite" },
];

/** Baked `MAINMENU.SCR` (320×200, palette `MAINMENU.PAL`), served by the `/baked/*` route. */
export const TITLE_BACKDROP_PATH = "/baked/screens/MAINMENU.SCR.png";

/** Baked `TITLE.SNG` — the title theme, re-synthesised by the bake pipeline. */
export const TITLE_MUSIC_PATH = "/baked/music/TITLE.ogg";

export function titleMenuItemAt(index: number): TitleMenuItem | undefined {
  return TITLE_MENU_ITEMS[index];
}

/** The route an Enter/Return on the given selection should navigate to. */
export function titleMenuTarget(index: number): string | undefined {
  return titleMenuItemAt(index)?.path;
}
